<div class="dialog-content-wrapper">
  <mat-toolbar class="mat-accent m-0">
    <mat-toolbar-row class="flex flex-row justify-between items-center flex-1">
      <span i18n class="title dialog-title">Оплата банковской картой</span>
      <button mat-button class="mat-icon-button" (click)="dialogRef.close(false)" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-4 pb-0 m-0" fusePerfectScrollbar>
    <ng-container>
      <p i18n class="mat-body-1"
        >Введите сумму, которую вы хотите оплатить. После нажатия кнопки "Перейти к оплате" вы будете перенаправлены на
        сайт банка для совершения платежа.</p
      >
      <p class="mat-body-1 warning-text" *ngIf="paymentFeeMsg !== ''">{{ paymentFeeMsg }}</p>
      <form
        method="post"
        action="https://3ds.payment.ru/cgi-bin/cgi_link"
        #formPSB
        class="flex flex-col justify-around">
        <input name="CURRENCY" value="{{ responseData.currancy }}" hidden />
        <input name="ORDER" value="{{ responseData.order }}" hidden />
        <input i18n-value name="DESC" value="Оплата заказа №{{ data.orderNumber }}" hidden />
        <input name="TERMINAL" value="{{ responseData.psbTerminal }}" hidden />
        <input name="TRTYPE" value="1" hidden />
        <input name="MERCH_NAME" value="{{ responseData.company }}" hidden />
        <input name="MERCHANT" value="{{ responseData.psbMerchant }}" hidden />
        <input name="EMAIL" value="{{ responseData.email }}" hidden />
        <input name="TIMESTAMP" value="{{ responseData.timestamp }}" hidden />
        <input name="NONCE" value="{{ responseData.nonce }}" hidden />
        <input name="BACKREF" value="{{ responseData.returnUrl }}" hidden />
        <input name="LANG" value="{{ responseData.language }}" hidden />
        <input name="P_SIGN" value="{{ responseData.hmac }}" hidden />
        <!-- <input name="AMOUNT" value="{{responseData.amount}}" hidden> -->

        <mat-form-field>
          <input i18n-placeholder matInput name="AMOUNT" [formControl]="amount" placeholder="Сумма" required />
          <span matSuffix>{{ currentCurrencySign }}</span>
          <mat-error *ngIf="amount.invalid">{{ getErrorMessage() }}</mat-error>
        </mat-form-field>
      </form>
    </ng-container>
  </div>

  <div mat-dialog-actions class="m-0 p-4 flex flex-row justify-end items-center">
    <button
      i18n
      mat-raised-button
      type="button"
      [disabled]="amount.invalid"
      class="mat-accent mr-4"
      (click)="psbPayClick()"
      >ПЕРЕЙТИ К ОПЛАТЕ</button
    >
    <button i18n mat-button (click)="dialogRef.close(false)">ОТМЕНА</button>
  </div>
</div>
